import React, { useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { Container } from './styles';

import MenuCategories from './components/MenuCategories';
import Products from './components/Products';
import ProductDetails from './components/ProductDetails';
import OrderDetails from './components/OrderDetails';
import OrderAddress from './components/OrderAddress';
import OrderConfirm from './components/OrderConfirm';

import { useProductsCompany } from '~/hooks/productsCompany';
import { useCartCompany } from '~/hooks/cartCompany';
import { useClients } from '~/hooks/clients';

const Home: React.FC = () => {
  const {
    showConfirmOrder,
    showOrderAddress,
    setOrderAddress,
    setOrderAddressText,
  } = useCartCompany();
  const { productSelected } = useProductsCompany();
  const { setSelectedClient, setNewClient } = useClients();

  useEffect(() => {
    setNewClient(null);
    setSelectedClient({} as any);
    setOrderAddress({} as any);
    setOrderAddressText('');
  }, [setOrderAddress, setOrderAddressText, setSelectedClient, setNewClient]);

  return (
    <Container>
      <main>
        <MenuCategories />
        <Products />
        <OrderDetails />

        {productSelected.uid && <ProductDetails />}
        {showOrderAddress && <OrderAddress />}
        {showConfirmOrder && <OrderConfirm />}
      </main>
    </Container>
  );
};

export default Home;
